import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showTopbarInsideAction } from "../../store/actions";
import withRouter from "../../components/Common/withRouter";
import { fnGetValueByKey } from "../../helpers/functions";
import BI_AUT001 from "../BI_AUT001";
import BI_AUT002 from "../BI_AUT002";
import BI_AUT003 from "../BI_AUT003"; 
import Error404Page from "./Error404-Page";
import { AuthProtectedContext } from "../../Routes/AuthProtectedContext";
import DynamicPageSkeleton from "./Dynamic-Page-Skeleton";
import BI_WS0000 from "../BI_WS0000";
import BI_AUT004 from "../BI_AUT004";
import { Alert } from "reactstrap";
import { Navigate } from "react-router-dom";

const SuspensePage = props => {
  const dispatch = useDispatch()

  const { transactionNotFound, transactionWithError, isIframePage } = useSelector(state => ({
    transactionNotFound: state.Layout.transactionNotFound,
    transactionWithError: state.Layout.transactionWithError,
    isIframePage: state.Layout.isIframePage
  }))

  const { transactionData, isLoading } = useContext(AuthProtectedContext)
  const template = fnGetValueByKey(transactionData, 'TEMPLATE')
  const isTransactionConfigured = fnGetValueByKey(
    transactionData,
    'TRANSACAO_CONFIGURAVEL'
  )
  const transactionRedirect = fnGetValueByKey(
    transactionData,
    'TRANSACAO_REDIRECT'
  )
  const transactionURLParams = fnGetValueByKey(
    transactionData,
    'TRANSACAO_URL_PARAMS'
  )

  useEffect(() => {
    if (Array.isArray(transactionData) && transactionData.length > 0)
      document.title =
        'Defender | ' +
        (fnGetValueByKey(transactionData, 'TITULO_TRANSACAO') ||
          props.router.location.pathname.split('/').pop())
  }, [transactionData])

  useEffect(() => {
    dispatch(showTopbarInsideAction({}))
  }, [])

  if(isIframePage && transactionWithError){
    console.log(transactionWithError?.payload)
  }

  if(transactionWithError?.payload?.status === 401) return <Navigate to={'/logout'} />

  if(isLoading) return <DynamicPageSkeleton />
  if(isTransactionConfigured === 'N' && transactionRedirect === 'BI_WS0000') return <BI_WS0000 URLParams={transactionURLParams}/>
  if(transactionNotFound) return <Error404Page />
  if(template === 'BI_AUT001') return <BI_AUT001 />
  if(template === 'BI_AUT002') return <BI_AUT002 />
  if(template === 'BI_AUT003') return <BI_AUT003 />
  if(template === 'BI_AUT004') return <BI_AUT004 />

  if(transactionWithError){
    return (
      <div className={`page-content`}>
        <Alert color="secondary">
          <h4 className="alert-heading">
            {transactionWithError?.payload?.status} {transactionWithError?.payload?.statusText} - Erro interno, ao consultar o backend!
          </h4>
          <hr />
          {!isIframePage && <pre className="bg-dark text-white p-3 rounded">{JSON.stringify(transactionWithError?.payload, null, 2)}</pre>
          }
        </Alert>
      </div>
    )
  }
  return <></>
}

export default withRouter(SuspensePage);